import { Tab, TabGroup, TabList } from '@headlessui/react';
import clsx from 'clsx';

export interface TabItem {
  name: string;
  icon?: ({ selected }: { selected: boolean }) => JSX.Element;
  subText?: string;
  value?: string;
}

interface TabsProps {
  items: TabItem[];
  selectedIndex: number;
  onChange: (index: number, value?: string) => void;
  className?: string;
}

export function Tabs({
  items,
  selectedIndex,
  onChange,
  className,
}: TabsProps): JSX.Element {
  return (
    <TabGroup
      selectedIndex={selectedIndex}
      onChange={(index) => {
        if (items[index]?.value) {
          onChange(index, items[index].value);
        } else {
          onChange(index);
        }
      }}
      className="w-full"
    >
      <TabList
        className={clsx(
          'flex flex-shrink-0 pt-2 items-center self-stretch border-b-2 border-gray-300',
          className,
        )}
      >
        {items.map((item) => (
          <Tab key={item.name} className="outline-none">
            {({ selected }) => (
              <div
                className={clsx(
                  'flex items-center gap-2 px-4 py-2 text-md text-gray-600 ',
                  'border-b-2 -mb-px',
                  selected
                    ? 'font-medium text-primary border-primary'
                    : 'font-normal border-transparent',
                )}
              >
                {item.icon && item.icon({ selected })}
                <div
                  className={clsx(
                    'flex flex-row flex-shrink-0 items-center justify-center gap-1',
                    selected ? 'text-gray-950' : '',
                  )}
                >
                  <span>{item.name}</span>
                  {item.subText && <span>{`( ${item.subText} )`}</span>}
                </div>
              </div>
            )}
          </Tab>
        ))}
      </TabList>
    </TabGroup>
  );
}
